/* All user operations */

import Settings from "./settings";
import Storage from "./storage.service";
import HTTP from "./http.service";
// import Events from "./events.service";
import Translations from "./translation";

var User = {};

User.fetching = false;

User.init = () => {
	// Helpers.log("User.init()");

	if (
		window.localStorage.getItem("session") &&
		window.localStorage.getItem("device_id")
	) {
		Storage.set("session", window.localStorage.getItem("session"));

		// Events.when_user_session_is_found();
		Storage.set("device_id", window.localStorage.getItem("device_id"));

		HTTP.set_device_id(Storage.get("device_id"));
		HTTP.set_session(Storage.get("session"));
	} else {
		window.localStorage.removeItem("session");
		window.localStorage.removeItem("device_id");
		Storage.clear("is_resident");
	}

	if (window.localStorage.getItem("session_email")) {
		Storage.set(
			"session_email",
			window.localStorage.getItem("session_email")
		);
	}
};

User.get = (property) => {
	return User[property] ? User[property] : "";
};

User.doLogout = (extras = null) => {
	// Events.when_user_logs_out();
	var rand = Math.floor(Math.random() * 10000000000 + 1); // Helpers.generateDeviceID();
	HTTP.set_device_id(rand);
	HTTP.set_session("");

	Storage.wipe();

	if (window.FB) {
		window.FB.getLoginStatus(function(response) {
			if (response.status === "connected") {
				this.state.FB.logout();
			}
		});
	}

	if (window.gapi && window.gapi.auth2) {
		var auth2 = window.gapi.auth2.getAuthInstance();
		if (auth2.isSignedIn.get()) {
			auth2.signOut();
		}
	}

	if (extras && extras["callback"]) {
		extras["callback"]();
	}
};

User.errorLogout = () => {
	if (!Storage.get("loggingByDeviceID")) {
		User.doLogout();
	}
};

User.logout = (extras = null) => {
	// Helpers.log("User.logout callee = " + callee + " with extras = " + extras);
	User.doLogout(extras);
};

User.updateFlowStatus = (key, value) => {
	// Helpers.log("User.getFlowStatus()");
	let config = {
		method: "post",
		url: "/me/flow_status",
		data: {
			key: key,
			value: value,
		},
	};
	return HTTP(config);
};

User.flowStatus = (callee = "default") => {
	// Helpers.log("User.flowStatus callee " + callee);

	let request = new Promise((resolve, reject) => {
		resolve(null);
	});

	if (User.isLoggedIn()) {
		if (Storage.get("fetching_flags")) {
			request = Storage.get("fetching_flags");
		} else {
			let config = {
				method: "get",
				url: "/me/flow_status",
			};

			request = HTTP(config);
			Storage.set("fetching_flags", request);
		}

		request
			.then((response) => {
				Storage.set("fetching_flags", false);
				if (response.data && response.data.flow_status_flags) {
					Storage.set(
						"flow_status_flags",
						response.data.flow_status_flags
					);
				}
			})
			.catch((error) => {
				Storage.set("fetching_flags", false);
			});
	}
	return request;
};

User.isLoggedInProper = () => {
	let flags = Storage.get("flow_status_flags");
	return Storage.get("session") && flags && flags["is_logged_in_via_email"]
		? true
		: false;
};

User.socialLogin = (data) => {
	let config = {
		method: "post",
		url: "/securitymanagement/social_login",
		data: data,
	};
	return HTTP(config);
};

User.loginByDeviceID = function() {
	let config = {
		method: "post",
		url: "/securitymanagement/login_by_device_id",
	};

	Storage.set("loggingByDeviceID", true);

	let ff = HTTP(config);

	ff
		.then((res) => {
			Storage.set("loggingByDeviceID", false);
		})
		.catch((error) => {
			Storage.set("loggingByDeviceID", false);
		});

	return ff;
};

User.login = function(UserData) {
	let config = {
		method: "post",
		url: "/securitymanagement/login",
		data: UserData,
	};
	return HTTP(config);
};

User.profile = function(UserData) {
	let config = {
		method: "get",
		url: "/securitymanagement/me",
	};
	return HTTP(config);
};

User.check_email = function(UserData) {
	let config = {
		method: "post",
		url: "/securitymanagement/check_email",
		data: UserData,
	};
	return HTTP(config);
};

User.register = function(UserData) {};

User.setPassword = function(UserData) {
	let config = {
		method: "post",
		url: "/securitymanagement/set_password",
		data: UserData,
		// headers: {
		// 	"password": UserData.password,
		// }
	};

	return HTTP(config);
};

User.isLoggedIn = function(argument) {
	return Storage.get("session") ? true : false;
};

User.getPreference = (preference_key) => {
	let preferences = {
		anghami: {
			PreferenceID: Settings.anghami_preference_id,
			Value: "true",
			translation_label: "ANGHAMI_AGREE",
		},
		newsletter: {
			PreferenceID: 10,
			Value: "true",
			translation_label: "NUMBER_TOBE_ADDED_TO_DNCR_CHECKBOX",
		},
		allow_share_spotii: {
			PreferenceID: 9,
			Value: "true",
			translation_label: "SPOTII_PREFERENCE_LINE",
		},
	};
	let preference = preferences[preference_key] || false;
	if (preference) {
		if (
			Translations["keys"] &&
			Translations["keys"][Translations.activeLang]
		) {
			preference["LabelInformation"] =
				Translations["keys"][Translations.activeLang][
					preference["translation_label"]
				];
		}
		delete preference["translation_label"];
		return preference;
	}
	return null;
};

User.saveID = (data) => {
	let config = {
		method: "post",
		url: "/me/id_details",
		data: data,
	};
	return HTTP(config);
}

User.setPreference = function(data) {
	let config = {
		method: "post",
		url: "/me/preferences",
		data: data,
	};
	return HTTP(config);
};

User.setConsent = function(data) {
    let config = {
        method: "post",
        url: "/consent.json",
        data: data,
    };
    return HTTP(config);
};

User.getConsent = function() {
    let config = {
        method: "get",
        url: "/consent.json?code=legalstuff",
    };
    return HTTP(config);
};

export default User;
